export default __webpack_public_path__ + "static/media/telegram_1.a9c4f82c.svg";